import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Ico from './iconBox';

// import aboutBlog from '../assets/images/blog_1.jpg';
// import person1 from '../assets/images/person_1.jpg';
// import person2 from '../assets/images/person_2.jpg';
// import person3 from '../assets/images/person_3.jpg';
// import person4 from '../assets/images/person_4.jpg';

class About extends Component {
    state = {

    }
    componentDidMount(){
        window.scrollTo(0, 0)

    }
    render() {
        return (
            <div>
            
        

          <nav aria-label="breadcrumb" className="breadcrumb-nav mb-2">
            <div className="container">
              <ol className="breadcrumb">
  <li className="breadcrumb-item">
    <a href="/">الرئيسية</a>
  </li>

  <li
    className="breadcrumb-item"
    style={{ fontWeight: "800", color: "#008071" }}
  >
    <a>عن الشركة</a>
  </li>
</ol>

            </div>{/* End .container */}
          </nav>{/* End .breadcrumb-nav */}



        

<div className='container' style={{margin : "30px 10px"}}>
            <div className='row'  >
            <div className="col-lg-8 col-sm-12" style={{margin  :"auto"}}>


         <center>
       <h1 style={{fontSize:"34px",fontWeight:"800",margin:"0px",color:"#008071"}}>
شركة ألوان القوس للدهانات – الرياض
</h1>

<p style={{color:"black",textAlign:"justify",lineHeight:"1.8"}}>
مرحباً بكم في <b>شركة ألوان القوس للدهانات</b>، وجهتكم الأولى في الرياض للحصول على أفضل الدهانات الداخلية والخارجية بجودة عالية وأسعار مناسبة.

نحن متخصصون في بيع جميع أنواع الدهانات، مواد التشطيب، واكسسوارات الدهان، مع خدمة تركيب وصيانة عند الطلب.
<br/><br/>

نقدم منتجات أصلية من أفضل الموردين، بألوان متعددة وتصاميم حديثة تناسب المنازل، الشركات، المشاريع العقارية، والمقاولين.
<br/><br/>

<h1 style={{fontSize:"30px",fontWeight:"800",margin:"0px",color:"#008071"}}>
💚 لماذا تختارنا؟
</h1>

✅ <b>جودة ممتازة:</b> دهانات مقاومة للعوامل الجوية والرطوبة  
<br/>
✅ <b>تنوع كبير:</b> ألوان حديثة، دهانات داخلية وخارجية، معادن، ديكورات  
<br/>
✅ <b>أسعار تنافسية:</b> بدون المساومة على الجودة  
<br/>
✅ <b>خدمة سريعة:</b> توصيل داخل الرياض + تركيب عند الطلب  
<br/>
✅ <b>ضمان ورضا العميل:</b> التزامنا هو الجودة والدقة  
<br/><br/>

🌟 سواء كنت صاحب منزل، مهندس، أو مقاول — نحن هنا لتلبية جميع احتياجات الدهان لديك.  
تواصل معنا الآن للحصول على أفضل العروض والخدمة الاحترافية!
🌈🛠️
</p>



          
         </center>
        
           
          
            </div>
            </div>
            </div>


            <div className="container icon-boxes-section">
                <div className="icon-boxes-container py-4 bg-lighter mb-2 mt-2">

                  <div>
                 
                 < Ico/>
                

                  </div>

                </div>
                </div>



            {/* </div> */}
        
          </div>
        )
    }
}

export default About;